import service from "services/maintenance/employmentStatusService";
import { RealEstateAgentOutlined } from "@mui/icons-material";
import MAINTENANCE_STORE_SELECTORS from "features/maintenance/dataStore/selectors";

const employmentStatusResource = {
    title: "Employment Status",
    singular: "Employment Status",
    displayField: "description",
    service: service,
    pageIcon: RealEstateAgentOutlined,
    setter: MAINTENANCE_STORE_SELECTORS.EMPLOYMENT_STATUS,
    columns: [
        {
            field: "employmentStatusCode",
            header: "Employment Status Code",
            width: "15%"
        },
        {
            field: "description",
            header: "Description"
        }
    ],
    fields: [
        {
            name: "employmentStatusCode",
            label: "Employment Status Code",
            type: "text",
            required: true,
            unique: true
        },
        {
            name: "description",
            label: "Description",
            type: "text",
            required: true
        }
    ],
    searchFields: ["EmploymentStatusCode", "description"]
};

export default employmentStatusResource;
